

































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BaseUser } from '../../../services/shared/auth';
import BaseComponent from '../../../core/base.component';
import AdminService from '../../../services/admin.service';
import InquiryService from '../../../services/inquiry.service';
import {
  AdminDto,
  InquiryDto,
  InquiryListDto,
  InquiryReplyListDto,
  InquiryReplyUpdateDto,
} from '../../../dto';
import { Pagination, OrderByValue } from '../../../common';
import JwtStorageService from '../../../services/shared/auth/jwt-storage.service';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'InquiryReplyList',
})
export default class InquiryReplyList extends BaseComponent {
  @Prop() readonly isClosed: {
    type: boolean;
  };
  private admin = new AdminDto(BaseUser);
  private inquiryReplyList: InquiryDto[] = [];
  private inquiryReplyListCount = 0;
  private inquiryReplyCreateDto = new InquiryDto();
  private inquiryReplyListDto = new InquiryReplyListDto();
  private inquiryReplyUpdateDto = new InquiryReplyUpdateDto();
  private pagination = new Pagination();
  private selectedReply: InquiryDto = new InquiryDto();
  private selectedReplyContent = null;
  private selectedReplyNo = null;

  // 답변 리스트
  findAll(isPagination?: boolean) {
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.pagination.limit = 5;

    InquiryService.findForReply(
      this.$route.params.id,
      this.inquiryReplyListDto,
      this.pagination,
    ).subscribe(res => {
      this.inquiryReplyList = res.data.items;
      this.inquiryReplyListCount = res.data.totalCount;
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  // 관리자
  findAdmin() {
    AdminService.findMe().subscribe(res => {
      this.admin = res.data;
    });
  }

  // 답변 작성 모달
  showReplyModal() {
    this.$bvModal.show('add_reply');
  }

  // 답변 작성
  createReply() {
    InquiryService.createReply(
      this.$route.params.id,
      this.inquiryReplyCreateDto,
    ).subscribe(res => {
      if (res) {
        this.findAll();
        this.clearOutReplyDto();
        toast.success('작성완료');
      }
    });
  }

  // 답변 작성 초기화
  clearOutReplyDto() {
    this.inquiryReplyCreateDto = new InquiryDto();
  }

  // 답변 수정
  selectReply(reply) {
    this.selectedReply = reply;
    this.selectedReplyContent = this.selectedReply.content;
    return (
      (this.selectedReplyNo = this.selectedReply.no),
      (this.selectedReplyContent = this.selectedReply.content)
    );
  }
  updateReply() {
    if (this.selectedReplyContent) {
      this.inquiryReplyUpdateDto.content = this.selectedReplyContent;
    }
    const replyId = this.selectedReplyNo;
    InquiryService.updateReply(
      this.$route.params.id,
      replyId,
      this.inquiryReplyUpdateDto,
    ).subscribe(res => {
      if (res) {
        this.$bvModal.hide('update_reply');
        this.findAll();
        toast.success('수정완료');
      }
    });
  }

  created() {
    this.pagination.page = 1;
    this.findAll();
    this.findAdmin();
  }
}
